/**
 * Theme: database → browser.
 *
 * Each client has an `accentColor` stored in the database. On login, the API
 * returns it in the auth response. The frontend calls applyTheme(accent) once
 * to set CSS custom properties on <html>. Tailwind class names like
 * `bg-accent` then resolve at runtime via `var(--color-accent)`.
 *
 * Only the accent changes per client — everything else is static grayscale.
 */

function withAlpha(hex, aa) {
  // Defensive: accept "#rrggbb" or pass through short-form unchanged.
  if (!hex || hex[0] !== "#") return hex;
  return hex.length === 7 ? hex + aa : hex;
}

export function applyTheme(accentColor) {
  const root = document.documentElement;

  // Accent variants — tinted overlays for subtle backgrounds/borders.
  root.style.setProperty("--color-accent", accentColor);
  root.style.setProperty("--color-accent-bg",     withAlpha(accentColor, "0a"));
  root.style.setProperty("--color-accent-border", withAlpha(accentColor, "30"));
  root.style.setProperty("--color-accent-soft",   withAlpha(accentColor, "18"));

  // Static tokens — Concept B: Light + Clean.
  root.style.setProperty("--color-bg",              "#fafafa");
  root.style.setProperty("--color-surface",         "#ffffff");
  root.style.setProperty("--color-border",          "#e5e5e5");
  root.style.setProperty("--color-border-light",    "#f0f0f0");
  root.style.setProperty("--color-text",            "#171717");
  root.style.setProperty("--color-text-secondary",  "#525252");
  root.style.setProperty("--color-text-muted",      "#a3a3a3");
}
